import { baseURL } from "../utilits/config";
import axios from "axios";

export function addNewMarketName(marketData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-market",
    headers: {
      "Content-Type": "application/json",
    },
    data: marketData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getAllMarkertName(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-market",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
